import { render, staticRenderFns } from "./bdd-acts.vue?vue&type=template&id=d39a6e34"
import script from "./bdd-acts.vue?vue&type=script&lang=js"
export * from "./bdd-acts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports